'use es6';

let gates = {};
export default {
  get(gate) {
    if (gate) {
      return gates[gate];
    }

    return gates;
  },

  setGatesThatAreUngated(enabledGates) {
    gates = enabledGates.reduce((ungatedGates, gate) => {
      ungatedGates[gate] = true;
      return ungatedGates;
    }, {});
    return;
  }

};